import { render, staticRenderFns } from "./SelectableProductItem.vue?vue&type=template&id=4f53e6bd&"
import script from "./SelectableProductItem.vue?vue&type=script&lang=js&"
export * from "./SelectableProductItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectableProductItem.vue?vue&type=style&index=0&id=4f53e6bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports